import ScrollFade from "./scroll-fade"

export default function setListeners() {
  const els = document.querySelectorAll("[data-scroll-fade]")

  return [...els].map((el) => ScrollFade(el))
}
